export const NEW_CUSTOM_PRODUCT_DEFAULTS = {
  type: 'FERTILIZER',
  makeUp: 'SOLID'
} as const;

export default NEW_CUSTOM_PRODUCT_DEFAULTS;
